module.exports = __webpack_public_path__ + "img/leetcode.7e6c7b31.svg";